export const PlayingGameMode = {
  Real: 0,
  Demo: 1,
};
